import { supabase } from './supabase';

export const WORKER_URL = 'https://ao-intel-qbo-sync.jgrove33.workers.dev';

// fetch() to the QuickBooks Worker with the signed-in user's token attached.
export async function qboFetch(path, options = {}) {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error('Not signed in.');
  return fetch(WORKER_URL + path, {
    ...options,
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}), Authorization: `Bearer ${session.access_token}` }
  });
}
